export default __webpack_public_path__ + "static/media/petal_s2.402c6238.svg";